import { useGameStore } from '../../store/gameStore';

export const starThresholds: Record<string, number[]> = {
  blitzSimple: [20, 50, 100, 150, 200, 300],
  blitzDeluxe: [20, 50, 100, 150, 200, 300],
  endlessSimple: [20, 50, 150, 250, 400, 600],
  endlessDeluxe: [20, 50, 150, 250, 400, 600],
};

const resultTextThresholds = [
  Math.random() < 0.5 ? 'Hang in there! ' : 'Keep at it! ',
  Math.random() < 0.5 ? 'Not bad! ' : 'Pretty good! ',
  Math.random() < 0.5 ? 'Nice work! ' : 'Great job! ',
  Math.random() < 0.5 ? 'Impressive! ' : 'Excellent! ',
  Math.random() < 0.5 ? 'Amazing! ' : 'Fantastic! ',
  Math.random() < 0.5 ? 'Incredible! ' : 'Astounding! ',
  Math.random() < 0.5 ? 'Flawless! ' : 'Perfection! ',
];

export const getStarCount = () => {
  const mode = useGameStore.getState().mode;
  const points = useGameStore.getState().gameData[mode].points;
  const thresholds = starThresholds[mode];
  for (let i = 0; i < thresholds.length; i++) {
    if (points < thresholds[i]) return i;
  }
  return 6;
};

export const getResultText = () => {
  const mode = useGameStore.getState().mode;
  const points = useGameStore.getState().gameData[mode].points;
  const thresholds = starThresholds[mode];
  for (let i = 0; i < thresholds.length; i++) {
    if (points < thresholds[i]) return resultTextThresholds[i];
  }
  return resultTextThresholds[6];
};

export const getStarDisplay = () => {
  const display = [
    'No stars 😢',
    '⭐',
    '⭐⭐',
    '⭐⭐⭐',
    '⭐⭐⭐⭐',
    '⭐⭐⭐⭐⭐',
    'Grandmaster 👑',
  ];

  return display[getStarCount()];
};
